import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { FORM_PUBLIC_STATUS } from '../../../../../constants/ModelStatus';
import styles from './defaultPrint.module.scss';
import { renderInfoForType } from '../../../../../utils/helpers';
import CustomPrintDetails from './CustomPrintDetails';

export default function DefaultPrintTemplate(props) {
  const {
    formAnswer,
    formImage,
    isPrintWithoutData,
    RelatedField,
    selectedLang,
    EndOfthePage,
    mcgHeader,
    formSourceLinkedEntries
  } = props;
  const profile = useSelector(state => state.auth.profile);
  const renderWeatherObs = obs => (obs !== undefined
      ? `${obs.metar.summary} - ${obs.metar.temperature}${
          obs.metar.wind !== undefined ? `, ${obs.metar.wind}` : ''
        }${
          obs.metar.humidity !== undefined
            ? `, Humidity - ${obs.metar.humidity}`
            : ''
        }`
      : '');

  const shortYear = new Date()
    .getFullYear()
    .toString()
    .slice(-2);
  const formOrderNumber = () => (formAnswer?.settings?.hide_order_number_in_print
      ? ''
      : `${formAnswerSequenceNum}`);

  let formAnswerSequenceNum = `#${shortYear} - ${formAnswer?.order_number}`;
  if (
    formAnswer?.settings?.enable_auto_increment_field
    && formAnswer?.settings?.auto_increment_field_def?.enable_auto_gen_as_form_id
  ) {
    formAnswerSequenceNum = formAnswer?.auto_gen;
  }

  const approvals = [];
  const approvalsList = formAnswer?.process?.approvals?.filter(approval => approval?.status !== 'send_back_loop');
  if (approvalsList?.length > 0) {
    approvalsList.forEach((approval) => {
      const approvalStep = formAnswer?.form_version?.process_def?.approvals?.steps?.filter(
        step => step?.id === approval?.step_id
      )?.[0];
      if (approvalStep) {
        approvals.push({
          ...approval,
          step: approvalStep
        });
      }
    });
  }
  const displayFormExportHeader = () => {
    if (
      formAnswer?.settings?.template_header
      && formAnswer?.settings?.header_description
    ) {
      return formAnswer?.settings?.header_description;
    }
    return '';
  };
  let showHeadingInfo = {};
  let typeFieldInfo = {};
  const showHeading = formSourceLinkedEntries?.map(entry => entry?.form_version?.schema?.fields?.filter(
      f => f?.type !== 'attachments'
        && f?.type !== 'signature'
        && f?.type !== 'dataSource' && f?.dataSourceID !== 'ds6'
    ))?.[0];
  if (showHeading) {
    showHeading.forEach((titleVal) => {
      showHeadingInfo = { ...showHeadingInfo, [titleVal?.title]: titleVal.id };
      typeFieldInfo = { ...typeFieldInfo, [titleVal?.id]: { ...titleVal } };
    });
  }
  return (
    <>
      <div className={`${styles.container}`}>
        <div className={styles.stepInfo}>
          <div className={styles.containermain}>
            {profile?.portal_airport?.logo ? (
              <>
                <div className={styles.infoHalfLeft1}>
                  <span>
                    <img
                      src={profile?.portal_airport?.logo}
                      style={{ maxWidth: '200px', maxHeight: '200px' }}
                      alt="airport_logo"
                      id="airportLogo"
                    />
                  </span>
                </div>
                <div className={styles.infoHalfRight2}>
                  <div className={styles.infosidehead}>
                    {profile?.portal_airport?.name}
                  </div>
                  <div
                    className={styles.infosidehead}
                    style={{ fontSize: '26px', paddingTop: '30px' }}
                  >
                    {formAnswer?.title} {formOrderNumber()}
                  </div>
                  <div
                    className={styles.infosidehead}
                    style={{
                      fontSize: '26px',
                      paddingTop: '30px',
                      paddingBottom: '20px'
                    }}
                  >
                    {displayFormExportHeader()}
                  </div>
                </div>
              </>
            ) : (
              <div
                className={styles.infoHalfRight2}
                style={{
                  textAlign: 'center',
                  marginLeft: '150px',
                  height: '80px'
                }}
              >
                <div
                  className={styles.infosidehead}
                  style={{
                    fontSize: '16px',
                    marginBottom: '20px',
                    marginTop: '20px'
                  }}
                >
                  {profile?.portal_airport?.name}
                </div>
                <div
                  className={styles.infosidehead}
                  style={{ fontSize: '16px', marginBottom: '20px' }}
                >
                  {profile?.portal_airport?.name}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
          <>
            {formAnswer?.settings?.show_additional_info_print && (
              <div
                className={styles.infoFull}
                style={{ borderTop: '1px solid #e6eaee' }}
              >
                <span>
                  <FormattedMessage
                    id="customfield.information"
                    defaultMessage="Instructions/Information"
                  />
                </span>
                <pre
                  style={{
                    border: 'none',
                    paddingTop: '10px',
                    fontFamily: 'Lato, sans-serif',
                    fontSize: '20px'
                  }}
                >
                  {formAnswer.form_version.additionalInfo}
                </pre>
              </div>
            )}
            {formAnswer?.source !== FORM_PUBLIC_STATUS && (
              <div
                className={
                  isPrintWithoutData ? styles.infoHalf1 : styles.infoHalf
                }
                style={{ borderTop: '1px solid #e6eaee' }}
              >
                <span>
                  <FormattedMessage
                    id="forms.step2.created_by"
                    defaultMessage="Created By"
                  />
                </span>
                {!isPrintWithoutData && (
                  <p>{formAnswer?.created_by?.fullname}</p>
                )}
              </div>
            )}
            {formAnswer?.source === FORM_PUBLIC_STATUS && (
              <>
                <div
                  className={
                    isPrintWithoutData ? styles.infoHalf1 : styles.infoHalf
                  }
                  style={{
                    borderTop: '1px solid #E6EAEE',
                    borderBottom: 'none'
                  }}
                >
                  <span>
                    <FormattedMessage
                      id="forms.step2.source"
                      defaultMessage="Source"
                    />
                  </span>
                  <p>Public Form</p>
                </div>
                {formAnswer?.public_user
                  && Object.keys(formAnswer?.public_user).map(f => (
                    <>
                      {f !== 'none' && formAnswer?.public_user[f] === true && (
                        <div
                          key={f.id}
                          className={
                            isPrintWithoutData
                              ? styles.infoHalf1
                              : styles.infoHalf
                          }
                          style={{
                            borderTop: '1px solid #E6EAEE',
                            borderBottom: 'none'
                          }}
                        >
                          <span>{f}</span>
                          {!isPrintWithoutData && (
                            <p>{formAnswer?.public_user_info[f]}</p>
                          )}
                        </div>
                      )}
                    </>
                  ))}
              </>
            )}
            <div
              className={
                isPrintWithoutData ? styles.infoHalf1 : styles.infoHalf
              }
              style={{ borderTop: '1px solid #e6eaee' }}
            >
              <span>
                <FormattedMessage
                  id="forms.step2.created_date"
                  defaultMessage="Created On"
                />
              </span>
              {!isPrintWithoutData && (
                <p style={{ fontSize: '24px' }}>
                  {renderInfoForType(
                    { type: 'datetime' },
                    formAnswer?.form_date,
                    null,
                    null
                  )}
                </p>
              )}
            </div>
            {formAnswer?.auto_gen && formAnswer?.auto_gen !== '' && (
              <div
                className={
                  isPrintWithoutData ? styles.infoFull1 : styles.infoFull
                }
                style={{ borderTop: '1px solid #e6eaee' }}
              >
                <span>
                  {formAnswer?.settings?.auto_increment_field_def
                    ?.field_title ?? 'Auto increment field'}
                </span>
                {!isPrintWithoutData && (
                  <p style={{ fontSize: '24px' }}>{formAnswer?.auto_gen}</p>
                )}
              </div>
            )}
            {formAnswer?.weather_conditions?.current_obs && (
              <div
                key="weather_obs"
                className={
                  isPrintWithoutData ? styles.infoFull1 : styles.infoFull
                }
                style={{ borderTop: '1px solid #e6eaee' }}
              >
                <span>
                  <FormattedMessage
                    id="inspections.answer_details.weatherobservation"
                    defaultMessage="Weather Observations"
                  />
                </span>
                {!isPrintWithoutData && (
                  <div
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: renderWeatherObs(
                        formAnswer?.weather_conditions?.current_obs
                      )
                    }}
                    style={{ fontSize: '24px' }}
                  />
                )}
              </div>
            )}
            {formAnswer?.weather_conditions?.current_obs?.metarRaw
              && formAnswer?.settings?.get_metar_raw_info && (
                <div
                  className={
                    isPrintWithoutData ? styles.infoFull1 : styles.infoFull
                  }
                >
                  <span>
                    <FormattedMessage
                      id="forms.details.weather_condition.metar_raw_information"
                      defaultMessage="METAR raw information"
                    />
                  </span>
                  {!isPrintWithoutData && (
                    <div style={{ fontSize: '24px' }}>
                      {formAnswer?.weather_conditions?.current_obs?.metarRaw}
                    </div>
                  )}
                </div>
              )}
          </>
        </div>
        <CustomPrintDetails
          data={formAnswer?.data}
          formImage={formImage}
          version={formAnswer?.form_version}
          fields={formAnswer?.form_version?.schema?.fields}
          selectedLang={selectedLang || formAnswer?.meta_data?.language || ''}
          isPrintWithoutData={isPrintWithoutData}
          attachmentEndOfthePage={EndOfthePage}
          attachmentRelatedField={RelatedField}
          mcgHeader={mcgHeader}
        />
      </div>
      {approvals?.map(approval => (
        <div className={`${styles.container}`}>
          <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
            <>
              <div
                className={
                  isPrintWithoutData ? styles.infoFull1 : styles.infoFull
                }
              >
                <span>{approval?.step?.title}</span>
              </div>
              <div
                className={
                  isPrintWithoutData ? styles.infoHalf1 : styles.infoHalf
                }
                style={{ borderTop: '1px solid #e6eaee' }}
              >
                <span>
                  <FormattedMessage
                    id="workorder.detail.info.completed_by"
                    defaultMessage="Completed by"
                  />
                </span>
                {!isPrintWithoutData && <p>{approval?.logged_by?.fullname}</p>}
              </div>
              <div
                className={
                  isPrintWithoutData ? styles.infoHalf1 : styles.infoHalf
                }
                style={{ borderTop: '1px solid #e6eaee' }}
              >
                <span>
                  <FormattedMessage
                    id="workorder.detail.info.completed_on"
                    defaultMessage="Completed on"
                  />
                </span>
                {!isPrintWithoutData && (
                  <p style={{ fontSize: '24px' }}>
                    {renderInfoForType(
                      { type: 'datetime' },
                      approval?.completed_date,
                      null,
                      null
                    )}
                  </p>
                )}
              </div>
            </>
          </div>
          <CustomPrintDetails
            data={approval?.data || {}}
            version={{ schema: { fields: approval?.step?.fields || [] } }}
            fields={approval?.step?.fields || []}
            selectedLang={selectedLang || formAnswer?.meta_data?.language || ''}
            attachmentEndOfthePage={EndOfthePage}
            attachmentRelatedField={RelatedField}
            mcgHeader={mcgHeader}
          />
          <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
            <div
              className={
                isPrintWithoutData ? styles.infoFull1 : styles.infoFull
              }
            >
              <span>
                <FormattedMessage
                  id="form.detail.info.description"
                  defaultMessage="Remarks/Comments"
                />
              </span>
              {!isPrintWithoutData && (
                <p style={{ fontSize: '1.8rem', fontFamily: 'Lato', whiteSpace: 'pre-line' }}>
                  {approval?.comment !== 'undefined' && approval?.comment}
                </p>
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
